import AppRoute from "./Template/AppRoute";

const App = () => {
  return (
      <AppRoute />
  );
};

export default App;
